import { GridColumns, GridRowParams } from '@mui/x-data-grid-premium';
import ConfirmationDeleteTableDialog from 'components/helpers/ConfirmationGridDelete';
import { useTranslation } from 'react-i18next';
import { baseCell } from '../cells/base-cell';
import { currencyCell } from '../cells/currency-cell';
import UpdateContractEquipmentDialog from 'components/inventory/Contracts/dialogs/UpdateContractEquipmentDialog';
import { numberFilterOperators } from './../../../../constants';

export function ContractEquipmentColumns(
  handleEdit?: (id: number, row: any) => void,
  handleManualDelete?: (id: number) => void,
  disableEdit?: boolean
): GridColumns {
  const { t } = useTranslation();
  return [
    {
      field: 'equipment',
      headerName: t(`global.equipment`),
      width: 150,
      renderCell: baseCell
    },
    {
      field: 'description',
      headerName: t(`global.description`),
      width: 250,
      renderCell: baseCell
    },
    {
      field: 'yearly_lease_amount',
      headerName: t(`entities.contract-equipment.yearly_lease_amount`),
      width: 240,
      filterOperators: numberFilterOperators,
      renderCell: currencyCell,
      editable: false
    },
    {
      field: 'yearly_maintenance_amount',
      headerName: t(`entities.contract-equipment.yearly_maintenance_amount`),
      width: 240,
      filterOperators: numberFilterOperators,
      renderCell: currencyCell,
      editable: false
    },
    {
      field: 'purchase_amount',
      headerName: t(`entities.contract-equipment.purchase_amount`),
      width: 240,
      filterOperators: numberFilterOperators,
      renderCell: currencyCell,
      editable: false
    },
    {
      field: 'depreciation_years',
      headerName: t(`entities.contract-equipment.depreciation_years`),
      width: 200,
      filterOperators: numberFilterOperators,
      renderCell: baseCell
    },
    {
      field: 'annual_invoices',
      headerName: t(`entities.contract.annual_invoices`),
      filterOperators: numberFilterOperators,
      width: 200,
      renderCell: baseCell
    },
    {
      field: '',
      width: 100,
      type: 'actions',
      getActions: (params: GridRowParams) => {
        if (!disableEdit) {
          return [
            <UpdateContractEquipmentDialog
              key={12}
              contractEquipment={params.row}
              onSubmit={handleEdit}
            />,
            <ConfirmationDeleteTableDialog
              key={2}
              id={params.row['id']}
              handleDelete={handleManualDelete}
            />
          ];
        } else {
          return [];
        }
      }
    }
  ];
}
